/* Component Dependencies */
var eventCapacityTemplate = require('templates/eventAndCapacity.hbs');
var eventCapacityQuickGroupTemplate = require('templates/eventAndCapacity-quickGroup.hbs');

var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'eventAndCapacity',
  template: {
    'eventAndCapacity': eventCapacityTemplate,
    'eventAndCapacity-quickGroup': eventCapacityQuickGroupTemplate
  }
});
